import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {updateTemplateSocialAccount, } from "../../../../../actions";
import {Button, CircularProgress, DialogActions, IconButton, } from "@mui/material";
import {BRCustomizedTooltip as Tooltip} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import Select from "react-select";
import BBIconEdit from "../../../../../assets/bbCustomIcons/BBIconEdit";

const UpdateSocialAccountWidget = ({templateId=null, currentValue=null})=>{

    const {templates,  updatingTemplate, } = useSelector(({admin})=>admin);

    const accounts = templates && templates.accounts;
    const template = templates && templateId && templates.templates && templates.templates[templateId];

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [newValue, setNewValue] = useState(null);

    const handleSubmit = ()=>{
        console.log("Submitting these values", templateId, newValue)
        dispatch(updateTemplateSocialAccount(templateId, newValue));
        setOpen(false);
    }

    const accountsAsOptionsArray = accounts && Object.values(accounts).map((account)=>{
        return{
            ...account,
            label: <Tooltip title={account.sender_name}><p>{account.username}</p></Tooltip>,
            value: account.id,
        }
    })

    return(
        <div>
            {!updatingTemplate
                ? <span className={"m-0 p-0 d-inline"}>
                    {currentValue ? currentValue : "--"}&nbsp;
                    <IconButton onClick={()=>setOpen(true)} className={"m-0 p-0 d-inline"}>
                    <BBIconEdit style={{fontSize: "1rem"}} />
                </IconButton>
                </span>
                : <CircularProgress/>}

            {open && templateId &&
            <Dialog open={open}
                    fullScreen={false}
                    fullWidth={true}
                    maxWidth={"sm"}
                    className={"m-1 p-1 animated fadeIn animation-duration-6"}
                    aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent style={{height: "300px"}}>

                    <label htmlFor={"socialAccountId"}>Sent From:</label>
                    <Select options={accountsAsOptionsArray}
                            className="mt-1 my-sm-3"
                            name={"socialAccountId"}
                            id={"socialAccountId"}
                            defaultValue={template
                            && template.social_account
                            && template.social_account.id
                                ? accountsAsOptionsArray.find(x => x.value === template.social_account.id)
                                : accountsAsOptionsArray[0]}
                            onChange={(e)=>setNewValue(e.value)}
                        // value={"socialAccountId"
                    />

                </DialogContent>

                <DialogActions>
                    <Col lg={12}>

                        <Button onClick={()=>setOpen(false)}
                                variant="contained" color="primary"
                                style={{float: "right"}}>
                            Cancel
                        </Button>
                        <Button
                        className={"float-right"}
                        variant="contained" color="primary"
                        type={"submit"}
                        onClick={()=>handleSubmit()}
                    >
                        Submit
                    </Button>
                    </Col>
                </DialogActions>
            </Dialog>
            }
        </div>
    )
};

export default UpdateSocialAccountWidget;